import { Checkbox } from "primereact/checkbox";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #f3f4f6;
  border-radius: 6px;
  margin-bottom: 1rem;
`;

const Description = styled.span`
  color: #6b7280;
  font-size: 12px;
  margin-left: 0.5rem;
`;

/**
 * Form field: isDefault. Renders a checkbox that when checked marks the rule
 * as a global default (no provider/payer). Used inside the provider/payer
 * section of the payer-rule forms; the section itself watches this value and
 * hides the provider/payer inputs when checked.
 */
export function IsDefaultCheckbox() {
  const { control } = useFormContext<any>();
  return (
    <Controller
      name="isDefault"
      control={control}
      render={({ field: { value, onChange } }) => (
        <Wrapper>
          <Checkbox
            inputId="isDefault"
            checked={!!value}
            onChange={(e) => onChange(!!e.checked)}
          />
          <label
            htmlFor="isDefault"
            style={{ fontWeight: 600, cursor: "pointer" }}
          >
            Global default rule
          </label>
          <Description>
            No provider or payer. Other contracts can copy this rule.
          </Description>
        </Wrapper>
      )}
    />
  );
}
